import type { ComponentProps, ForwardedRef } from 'react';

import { forwardRef } from '@change-corgi/core/react/core';
import { Radio } from '@change-corgi/design-system/components/forms';
import { Box } from '@change-corgi/design-system/layout';

/* eslint-disable @typescript-eslint/naming-convention */
const radioCardStyles = {
	'&:hover': {
		boxShadow: '0px 6px 12px 0px rgba(0, 0, 0, 0.25)',
		borderRadius: 'standard',
	},
	'& > label': {
		borderRadius: 'standard',
		borderWidth: 1,
		borderColor: 'neutral-grey100',
		borderStyle: 'solid',
		backgroundColor: 'primary-greyBackground',
		display: 'flex',
		flexDirection: 'column-reverse',
		alignItems: 'center',
		'& > input[type="radio"]': {
			margin: 12,
		},
	},
	'& > label:focus-within, & > label[data-selected="true"]': {
		outlineRadius: 'standard',
		outlineWidth: 2,
		outlineStyle: 'solid',
		outlineColor: 'secondary-blue',
	},
	'& > label > input[type="radio"]:focus': {
		outline: 'none',
	},
	'& > label > .boolean-input-label': {
		overflow: 'hidden',
		borderTopRightRadius: 'standard',
		borderTopLeftRadius: 'standard',
		backgroundColor: 'background',
	},
} as const;
/* eslint-enable @typescript-eslint/naming-convention */

function RadioCardInner(props: ComponentProps<typeof Radio>, ref: ForwardedRef<HTMLInputElement>): JSX.Element {
	return (
		<Box sx={{ ...radioCardStyles }}>
			<Radio {...props} ref={ref} />
		</Box>
	);
}

export const RadioCard = forwardRef(RadioCardInner);
